var React = require('react');

function LinkedInIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m33.76 0h-31.63482c-.80977 0-1.457577.647812-1.457577 1.45758v31.68882c0 .7557.647807 1.4036 1.457577 1.4036h31.68882c.8097 0 1.4575-.6479 1.4575-1.4576v-31.63482c-.0539-.809768-.7018-1.45758-1.5115-1.45758zm-22.8354 29.4214h-5.12849v-16.4652h5.12849zm-2.59123-18.7325c-1.61953 0-2.96913-1.34962-2.96913-2.96914 0-1.61953 1.3496-2.96914 2.96913-2.96914s2.96913 1.34961 2.96913 2.96914c0 1.67351-1.2956 2.96914-2.96913 2.96914zm21.75573 18.7325h-5.1286v-7.9896c0-1.8895-.0539-4.3728-2.6452-4.3728-2.6452 0-3.0771 2.1054-3.0771 4.2108v8.1516h-5.1285v-16.4652h4.9126v2.2674h.054c.7017-1.2956 2.3753-2.6453 4.8585-2.6453 5.1825 0 6.1543 3.4011 6.1543 7.8278z","fill":"#80d8d0"}));
}

LinkedInIconInline.defaultProps = {"fill":"none","height":"35","viewBox":"0 0 36 35","width":"36"};

module.exports = LinkedInIconInline;

LinkedInIconInline.default = LinkedInIconInline;
